import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreateAsuntoRequest  extends CreateKeyValueRequest{
    
}